import { DialogContent, DialogContentProps } from "@mui/material";
type DialogComplexContentProps = DialogContentProps & {};
export const DialogComplexContent = (props: DialogComplexContentProps) => {
  return (
    <DialogContent
      {...props}
      sx={{ overflow: "hidden", display: "flex", flexDirection: "column" }}
    >
      {props.children}
    </DialogContent>
  );
};
